import api from './api';

/**
 * Recommendation service for fetching security recommendations
 * based on a user's unresolved privacy exposures.
 */
export const recommendationService = {
  /**
   * Get all recommendations for the current user grouped by exposure type.
   * @param {string} username - Reddit username (required)
   * @param {string} platform - Platform (default: reddit)
   * @returns {Promise<Array>}
   */
  getRecommendations: async (username, platform = 'reddit') => {
    try {
      if (!username) {
        console.error('Username is required for getRecommendations');
        return [];
      }
      const response = await api.get('/privacy/recommendations/', {
        params: { username, platform },
      });
      return response.data?.data || [];
    } catch (error) {
      console.error('Get recommendations error:', error);
      return [];
    }
  },
};

export default recommendationService;
